let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kejEt"), load("bVy01"), load("02lUE"), load("hDfPU")]).then(() => parcelRequire('2mD8T'));